const popup = (state = {
	popup:{},
	stage:2,
	component:false,
	rules:{},

}, action) => {

	let newState = state;
	let merge = false;

	switch(action.type) {
		case 'POPUP_REMOVE_RULE':
			merge = Object.keys(newState.rules)
			.filter(key => key != action.payload)
			.reduce((result, current) => {
				result[current] = newState.rules[current];
				return result;
			}, {});
			newState = {...newState,rules:merge};
		break;
		case 'POPUP_SET_RULE':
			newState = {
				...state,
				rules: {
					...state.rules,
					[action.payload.key]: action.payload.value
				}
			}
		break;

		case 'POPUP_SET_GLOBAL_KEY':
			newState = {
				...state,
				[action.payload.key]:action.payload.value
			}
		break;

		case 'POPUP_SET_POPUP_KEY':
			newState = {
				...state,
				popup: {
					...state.popup,
					[action.payload.key]: action.payload.value
				}
			}
		break;

		case 'POPUP_SET_SETTING_DATA':
			newState = {
				...state,
				popup: {
					...state.popup,
					settings: {
						...state.popup.settings,
						[action.payload.key]: action.payload.value
					}
				}
			}
		break;

		case 'POPUP_SET_CONTENT_DATA':
			newState = {
				...state,
				popup: {
					...state.popup,
					content: {
						...state.popup.content,
						[action.payload.key]: action.payload.value
					}
				}
			}
		break;

		case 'POPUP_SET_STYLE_DATA':
			newState = {
				...state,
				popup: {
					...state.popup,
					style: {
						...state.popup.style,
						[action.payload.selector]: {
							...state.popup.style[action.payload.selector],
							[action.payload.key]:action.payload.value
						}
					}
				}
			}
		break;

		case 'POPUP_SET_STYLE':
			newState = {
				...state,
				popup: {
					...state.popup,
					style: {
						...state.popup.style,
						[action.payload.key]:action.payload.value
					}
				}
			}
		break;

		case 'POPUP_SET_COMPONENT_STYLE':
			newState = {
				...state,
				component: {
					...state.popup,
					[action.payload.key]: action.payload.value
				}
			}
		break;

	}

	return newState;
}



export default popup;


// WEBPACK FOOTER //
// ./reducers/builderPopupReducer.js